import {useState} from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {getDays} from '../../helpers/scheduling';
import DayTabs from './DayTabs';
import DailyBlockSchedule from './DailyBlockSchedule';
import './ListAppointmentsScreen.css';

const days = getDays();

const handleDaySelect = ({date, setDate, onDateChange}) => newDate => {
  setDate(newDate);
  return onDateChange(newDate);
};

const handleIncrementDay = ({
  date,
  setDate,
  onDateChange,
  inc = 7,
  units = 'days'
}) => e => {
  const newDate = moment(date).add(inc, units);
  setDate(newDate);
  return onDateChange(newDate);
};

const ListAppointmentsScreen = props => {
  const {appointments, sessionTypes, startDate, onDateChange} = props;
  const [date, setDate] = useState(startDate);
  const [month, setMonth] = useState(startDate.format('MMMM'));
  const onDaySelect = handleDaySelect({date, setDate, onDateChange});
  const onPrevWeek = handleIncrementDay({date, setDate, onDateChange, inc: -7});
  const onNextWeek = handleIncrementDay({date, setDate, onDateChange, inc: 7});
  return (
    <Container maxWidth='md' style={{paddingBottom: '0px'}}>
      <Box style={{backgroundColor: '#ffffff'}}>
        <Stack
          direction='row'
          justifyContent='space-between'
          style={{paddingTop: '2em'}}
        >
          <IconButton color='primary' onClick={onPrevWeek}>
            <ChevronLeftIcon/>
          </IconButton>
          <Stack justifyContent='center'>
            <Typography variant='h3'>
              {date.format('MMMM, yyyy')}
            </Typography>
          </Stack>
          <IconButton color='primary' onClick={onNextWeek}>
            <ChevronRightIcon/>
          </IconButton>
        </Stack>
        <DayTabs date={date} onChange={onDaySelect} />
      </Box>
      <Box style={{backgroundColor: '#ffffff'}}>
        <Stack padding={2}>
          <Typography variant='h2' color='primary'>
            {date.format('dddd, MMMM D')}
          </Typography>
        </Stack>
      </Box>
      <DailyBlockSchedule
        appointments={appointments}
        sessionTypes={sessionTypes}
      />
    </Container>
  );
};

ListAppointmentsScreen.defaultProps = {
  startDate: moment(),
};

ListAppointmentsScreen.propTypes = {
  appointments: PropTypes.array,
  sessionTypes: PropTypes.array,
  startDate: PropTypes.object, // momentJS Object
  onDateChange: PropTypes.func, // momentJS Object
};

export default ListAppointmentsScreen;
